import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from 'react-router';
import { obtenir_page_meta } from '../services/pageService';
import Navigation from '../composants/commun/navigation';
import TitrePage from '../composants/commun/titre-page';
import PiedPage from '../composants/commun/pied-page';
import { obtenirValeur } from '../utils/localStorageUtil';
import EffectuerCommande from '../composants/effectuer-commande/effectuer-commande';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import ReactGA from "react-ga4";

export default function PageEffectuerCommande() {

    const [state, setState] = useState({
      metaPage: null
    });
    let location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
      !state.metaPage && obtenir_page_meta(location.pathname, state, setState)
    }, [state, location])

    useEffect(() => {
        const token = obtenirValeur("token", false)
        if(!token)
        {
            navigate("/inscription?source=commande")
        }
    }, [navigate])

    useEffect(() => {
      if(process.env.NODE_ENV !== "development" && state.metaPage && state.metaPage.titre_onglet)
      {
        ReactGA.initialize(process.env.REACT_APP_CODE_SUIVI_ANALYTICS);
        ReactGA.send(
          { 
            hitType: "pageview", 
            page: location.pathname, 
            title: state.metaPage.titre_onglet 
          } 
        );
      }
    }, [state, location])

    return (
      <PayPalScriptProvider 
        options={
          { 
            clientId: process.env.NODE_ENV !== "development" ? process.env.REACT_APP_CLE_CLIENT_PAYPAL_LIVE : process.env.REACT_APP_CLE_CLIENT_PAYPAL_SANDBOX,
            currency: "CAD",
            intent: "capture",
          }
        }
      >
        {
          state.metaPage &&
          <Helmet>
            <title>{state.metaPage.titre_onglet}</title>
            <link rel="canonical" href={process.env.REACT_APP_NOM_DOMAINE + state.metaPage.url_canonique} />
            <meta name="description" content={state.metaPage.description} />
            <link rel="icon" href={process.env.REACT_APP_NOM_DOMAINE_API + "/images/icones/icone-gw.png"}/>
            <meta property="og:locale" content="fr_CA"/>
            <meta property="og:title" content={state.metaPage.titre_onglet}/>
            <meta property="og:description" content={state.metaPage.description}/>
            <meta property="og:url" content={process.env.REACT_APP_NOM_DOMAINE + state.metaPage.url_canonique}/>
            <meta property="og:site_name" content="GreenWood Multimedia"/>
            <meta property="article:modified_time" content={state.metaPage.moment_modification}/>
            <meta name="twitter:card" content="summary"/>
            <meta name="twitter:label1" value="Écrit par"/>
            <meta name="twitter:data1" value="GreenWood Multimedia"/>
          </Helmet>
        }
        <Navigation />
        {
            state.metaPage &&
            <>
              <TitrePage>{state.metaPage.nom_page}</TitrePage>
              <EffectuerCommande />
            </>
        }
        <PiedPage />
      </PayPalScriptProvider>
    );
  }